/** Returns a function, that, as long as it continues to be invoked, will not
 * be triggered.
 *
 * Example usage:
 * function saveInput(){
 *  `console.log('Saving data');
 * }
 * `const processChange = debounce(() => saveInput());
 */
export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

/**
 * Selector is "imageslider_container" or children.
 * Returns the banners + links where available.
 * Mobile = true is for the mobile banner images.
 */
export function getEvoSliderBanners(selector, mobile = false) {
  let query;
  const banners = [];

  if (mobile) {
    query = document.querySelector(selector).querySelectorAll('.mobileimg .ms-slide');
  } else {
    query = document.querySelector(selector).querySelectorAll('.deskimg .ms-slide');
  }

  query.forEach((item) => {
    const banner = item.cloneNode(true);

    banner.classList.remove('ms-slide');
    banner.querySelector('img').classList.remove('responsive');

    if (banner.querySelector('a')) banner.querySelector('a').innerHTML = '';

    banner.removeAttribute('data-delay');
    banner.querySelector('.overlay').remove();
    banners.push(banner);
  });

  return banners;
}

/**
 * Selector is "doublebanner_container" / "singlebanner_container" or children.
 * Returns the banners + links where available.
 * Mobile = true is for the mobile banner images.
 */
export function getEvoBanners(selector, mobile = false) {
  let query;
  const banners = [];

  if (mobile) {
    query = document.querySelector(selector).querySelectorAll('.mobileimg');
  } else {
    query = document.querySelector(selector).querySelectorAll('.deskimg');
  }

  query.forEach((item) => {
    let banner;
    const img = item.cloneNode();
    img.classList.remove('mobileimg', 'deskimg', 'responsive');

    if (item.parentNode.localName === 'a') {
      banner = item.parentNode.cloneNode();
      banner.append(img);
    } else {
      banner = img;
    }

    banners.push(banner);
  });

  return banners;
}

/**
 * Replace .social with .nSocial
 * This is so we can style socials properly without un-styling the default
 */
(() => {
  document.querySelectorAll('.social').forEach((item) => {
    item.classList.remove('social');
    item.classList.add('nSocial');
  });
})();

/**
 * selectors to hide elements.
 * place these on the page-content evo widget where possible
 */
(() => {
  // add breadcrumb-hide class anywhere on page to hide row with breadcrumbs
  document.querySelectorAll('.js-breadcrumb-hide').forEach(() => {
    document.querySelectorAll('#breadcrumb').forEach((item) => {
      item.style.display = 'none';
    });
  });

  // margins for: zonetop, zonebottom, catalog-grid.
  if (document.querySelector('.js-zonetop-nomargin')) {
    document.querySelector('.zonetop').style.marginBottom = '0';
  }
  if (document.querySelector('.js-zonebottom-nomargin')) {
    document.querySelector('.zonebottom').style.marginTop = '0';
  }
  if (document.querySelector('.js-catalog-nomargin')) {
    document.querySelector('.catalog-grid').style.marginTop = '0';
  }

  // no margins for all: zonetop, zonebottom, catalog-grid.
  if (document.querySelector('.js-no-margins')) {
    document.querySelector('.zonetop').style.marginBottom = '0';
    document.querySelector('.zonebottom').style.marginTop = '0';
    document.querySelector('.catalog-grid').style.marginTop = '0';
  }

  // no margins for all, and hide breadcrumb
  if (document.querySelector('.js-no-margins-breadcrumb')) {
    document.querySelector('.zonetop').style.marginBottom = '0';
    document.querySelector('.zonebottom').style.marginTop = '0';
    if (document.querySelector('.catalog-grid')) {
      document.querySelector('.catalog-grid').style.marginTop = '0';
    }
    document.querySelectorAll('#breadcrumb').forEach((item) => {
      item.style.display = 'none';
    });
  }
})();

/**
 * Additional JS Selectors
 */
(() => {
  // add ieOnly class to body if the browser used is IE
  if (navigator.userAgent.match(/msie|trident/i)) {
    document.body.classList.add('ieOnly');
  }

  // add js-target-blank class to parent to allow target blank on 'a' children
  document.querySelectorAll('.js-target-blank a').forEach((item) => {
    item.target = '_blank';
  });

  // add js-customer-tools to element to toggle customer tools slide-in
  document.querySelectorAll('.js-customer-tools').forEach((item) => {
    item.addEventListener('click', () => {
      document.querySelectorAll('.customertools').forEach((tools) => {
        tools.classList.toggle('open');
      });
    });
  });

  // add body class to enable division popout
  if (document.querySelector('.js-division-popout')) {
    document.body.classList.add('ex-division-popout');
  }
})();

/**
 * Footer Links Menu Accordion
 * Add class "foot-menu" to menu widget in footer
 */
(() => {
  document.querySelectorAll('.foot-menu').forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('open');
    });
  });
})();
